// extracted by mini-css-extract-plugin
export var button = "_o7-2";
export var card = "_o7-0";
export var closeButtonContainer = "_o7-3";
export var iconContainer = "_o7-1";